import { render, staticRenderFns } from "./IndividualDatasetWidget.vue?vue&type=template&id=0685f57f&"
import script from "./IndividualDatasetWidget.vue?vue&type=script&lang=js&"
export * from "./IndividualDatasetWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports